import {
  getAll,
  getPage,
  getDetail,
  getHourly,
  getDaily,
  getMonthly,
  getYearly,
} from '@/api/memminutelyserv'

export default {
  state: {
    state_MemMinutely_GetAllResult: null,
    state_MemMinutely_GetPageResult: null,
    state_MemMinutely_GetDetailResult: null,
    state_MemMinutely_GetHourlyResult: null,
    state_MemMinutely_GetDailyResult: null,
    state_MemMinutely_GetMonthlyResult: null,
    state_MemMinutely_GetYearlyResult: null,
  },
  mutations: {
    SET_MEMMINUTELY_GETALL_RESULT: (state, rst) => {
      state.state_MemMinutely_GetAllResult = rst;
    },
    SET_MEMMINUTELY_GETPAGE_RESULT: (state, rst) => {
      state.state_MemMinutely_GetPageResult = rst;
    },
    SET_MEMMINUTELY_GETDETAIL_RESULT: (state, rst) => {
      state.state_MemMinutely_GetDetailResult = rst;
    },
    SET_MEMMINUTELY_GETHOURLY_RESULT: (state, rst) => {
      state.state_MemMinutely_GetHourlyResult = rst;
    },
    SET_MEMMINUTELY_GETDAILY_RESULT: (state, rst) => {
      state.state_MemMinutely_GetDailyResult = rst;
    },
    SET_MEMMINUTELY_GETMONTHLY_RESULT: (state, rst) => {
      state.state_MemMinutely_GetMonthlyResult = rst;
    },
    SET_MEMMINUTELY_GETYEARLY_RESULT: (state, rst) => {
      state.state_MemMinutely_GetYearlyResult = rst;
    },
  },
  actions: {
    MemMinutelyServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetHourly({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getHourly(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETHOURLY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETHOURLY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetDaily({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDaily(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETDAILY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETDAILY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetMonthly({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMonthly(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETMONTHLY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETMONTHLY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MemMinutelyServ_GetYearly({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getYearly(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEMMINUTELY_GETYEARLY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEMMINUTELY_GETYEARLY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_MemMinutely_GetAllResult: state => {
      return state.state_MemMinutely_GetAllResult;
    },
    get_MemMinutely_GetPageResult: state => {
      return state.state_MemMinutely_GetPageResult;
    },
    get_MemMinutely_GetDetailResult: state => {
      return state.state_MemMinutely_GetDetailResult;
    },
    get_MemMinutely_GetHourlyResult: state => {
      return state.state_MemMinutely_GetHourlyResult;
    },
    get_MemMinutely_GetDailyResult: state => {
      return state.state_MemMinutely_GetDailyResult;
    },
    get_MemMinutely_GetMonthlyResult: state => {
      return state.state_MemMinutely_GetMonthlyResult;
    },
    get_MemMinutely_GetYearlyResult: state => {
      return state.state_MemMinutely_GetYearlyResult;
    },
  }
}